<template>
  <div class="volume-unit">
    <div v-if="sampleAttribute === 'sampleComment'">
      <div
        v-for="(sample, index) in activeSamples"
        :key="sample.id"
      >
        <VTextarea
          v-model="analysisRequest.samples[index].comment"
          :readonly="isSummaryView"
          hideDetails
          dense
          outlined
          :rules="{ max: 50 }"
          data-cy="cell-sampleComment"
          @input="updateSample($event, 'comment', analysisRequest, analysisRequest.samples[index].id)"
        />
      </div>
    </div>
    <div v-else-if="sampleAttribute === 'labId'">
      <div
        v-for="(sample, index) in activeSamples"
        :key="sample.id"
      >
        <VTextField
          v-model="analysisRequest.samples[index].labId"
          :readonly="isSummaryView"
          hideDetails
          dense
          outlined
          @input="updateSample($event, 'labId', analysisRequest, analysisRequest.samples[index].id)"
        />
      </div>
    </div>
    <div v-else-if="sampleAttribute === 'type'">
      {{ $t(`analysisRequests.labels.template.sampleTypes.${analysisRequest.type.toLowerCase()}`) }}
    </div>
    <div v-else-if="sampleAttribute === 'systemVolumeImp'">
      <v-row>
        <v-col
          cols="12"
          class="no-height-padding"
        >
          <VTextField
            :value="systemVolumeImpGal"
            :label="$t('labWorkOrderTable.units.impGal')"
            disabled
            type="number"
            hideDetails
            dense
            outlined
            :readonly="isSummaryView"
          />
        </v-col>
      </v-row>
    </div>
    <div v-else-if="sampleAttribute === 'systemVolumeUsg'">
      <v-row>
        <v-col
          cols="12"
          class="no-height-padding"
        >
          <VTextField
            :value="systemVolumeUsGal"
            :label="$t('labWorkOrderTable.units.impGal')"
            disabled
            type="number"
            hideDetails
            dense
            outlined
            :readonly="isSummaryView"
          />
        </v-col>
      </v-row>
    </div>
    <div v-else-if="sampleAttribute === 'systemVolumeLiter'">
      <v-row>
        <v-col
          cols="12"
          class="no-height-padding"
        >
          <VTextField
            :value="systemVolumeLiter"
            :label="$t('labWorkOrderTable.units.impGal')"
            disabled
            type="number"
            hideDetails
            dense
            outlined
            :readonly="isSummaryView"
          />
        </v-col>
      </v-row>
    </div>
    <div v-else-if="sampleAttribute === 'timePeriodForWaterLosses'">
      <VTextField
        :value="timePeriodForWaterLosses"
        :label="$t('forms.labels.days')"
        disabled
        type="number"
        hideDetails
        dense
        outlined
        :readonly="isSummaryView"
      />
    </div>
    <div v-else-if="sampleAttribute === 'initialTracerConcentration'">
      <VTextField
        v-model="analysisRequest.samples[0].initialTracerConcentration"
        label="(mg/L)"
        :readonly="isSummaryView"
        hideDetails
        dense
        outlined
        @input="updateAnalysisRequest(sampleAttribute, $event, analysisRequest, null, true)"
      />
    </div>
    <div v-else-if="sampleAttribute === 'activeTracerQuantity'">
      <VTextField
        v-model="analysisRequest.samples[0].activeTracerQuantity"
        label="(g)"
        :readonly="isSummaryView"
        hideDetails
        dense
        outlined
        @input="updateAnalysisRequest(sampleAttribute, $event, analysisRequest, null, true)"
      />
    </div>
    <div v-else-if="sampleAttribute === 'finalTracerConcentration'">
      <VTextField
        v-model="analysisRequest.samples[0].finalTracerConcentration"
        label="(mg/L)"
        :readonly="isSummaryView"
        outlined
        hideDetails
        dense
        @input="updateAnalysisRequest(sampleAttribute, $event, analysisRequest, null, true)"
      />
    </div>
    <div v-else-if="sampleAttribute === 'blankConcentration'">
      <VTextField
        v-model="analysisRequest.samples[0].blankConcentration"
        label="(mg/L)"
        :readonly="isSummaryView"
        outlined
        hideDetails
        dense
        @input="updateAnalysisRequest(sampleAttribute, $event, analysisRequest, null, true)"
      />
    </div>
    <div v-else-if="sampleAttribute === 'waterLossTotal'">
      <VTextField
        :value="waterLossTotal"
        label="L"
        disabled
        type="number"
        hideDetails
        dense
        outlined
        :readonly="isSummaryView"
      />
    </div>
    <div v-else-if="sampleAttribute === 'waterLossRate'">
      <VTextField
        :value="waterLossRate"
        :label="$t('labWorkOrderTable.units.litersByDay')"
        disabled
        type="number"
        outlined
        hideDetails
        dense
        :readonly="isSummaryView"
      />
    </div>
    <div v-else-if="sampleAttribute === 'collectionLossDate'">
      <VDateTimePicker
        v-model="analysisRequest[sampleAttribute]"
        :disabled="isSummaryView"
        :locale="datePickerLocales[$store.getters.lang]"
        outlined
        hideDetails
        dense
        @input="updateAnalysisRequest(sampleAttribute, moment($event), analysisRequest, null)"
      />
    </div>
    <div v-else-if="sampleAttribute === 'tracerAddedDate'">
      <VDateTimePicker
        v-model="analysisRequest[sampleAttribute]"
        :disabled="isSummaryView"
        :locale="datePickerLocales[$store.getters.lang]"
        outlined
        hideDetails
        dense
        @input="updateAnalysisRequest(sampleAttribute, moment($event), analysisRequest, null)"
      />
    </div>
    <div
      v-else-if="sampleAttribute === 'samples'"
      style="width:222px"
    >
      <div
        v-for="sample in analysisRequest.samples"
        :key="sample.id"
        class="sample-chip"
        style="width: max-content"
      >
        {{ sample.identification || sample.id }}
      </div>
    </div>
    <div v-else-if="sampleAttribute === 'receivedDate'">
      <VDateTimePicker
        v-model="analysisRequest.samples[0].receivedDate"
        :readonly="isSummaryView"
        :locale="datePickerLocales[$store.getters.lang]"
        hideDetails
        dense
        @input="updateAnalysisRequest(sampleAttribute, moment($event), analysisRequest, null,true)"
      />
    </div>
    <div v-else-if="sampleAttribute === 'collectedDate'">
      <VDateTimePicker
        v-model="analysisRequest.samples[0].collectedDate"
        :readonly="isSummaryView"
        :locale="datePickerLocales[$store.getters.lang]"
        hideDetails
        dense
        @input="updateAnalysisRequest(sampleAttribute, moment($event), analysisRequest, null,true)"
      />
    </div>
    <div v-else-if="sampleAttribute === 'networkType'">
      <div v-if="analysisRequest.networkType">
        {{ analysisRequest.networkType.name }}
      </div>
    </div>
    <div v-else-if="sampleAttribute === 'componentType'">
      <div v-if="analysisRequest.component">
        {{ analysisRequest.component.type.name }}
      </div>
    </div>
    <div v-else-if="sampleAttribute === 'addedTracer'">
      <VSelect
        v-model="analysisRequest[sampleAttribute]"
        :label="$t('analysisRequests.contenance.addedTracer')"
        itemValue="key"
        :items="addedTracer"
        :readonly="isSummaryView"
        hideDetails
        dense
        outlined
        @change="updateAnalysisRequest(sampleAttribute, $event, analysisRequest, null)"
      />
      <VTextField
        v-if="analysisRequest.addedTracer === 'other'"
        v-model="analysisRequest.tracerComment"
        :readonly="isSummaryView"
        :label="$t('forms.labels.note')"
        hideDetails
        dense
        outlined
        @input="updateAnalysisRequest('tracerComment', $event, analysisRequest, null)"
      />
    </div>
    <div v-else>
      <VTextField
        v-model="analysisRequest[sampleAttribute]"
        :readonly="isSummaryView"
        outlined
        hideDetails
        dense
        @input="updateAnalysisRequest(sampleAttribute, $event, analysisRequest, null)"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import VTextarea from '@/components/shared/widgets/forms/VuetifyInputs/VTextarea.vue';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField';
import VDateTimePicker from '@/components/shared/widgets/forms/VuetifyInputs/VDateTimePicker';
import addedTracer from '@/constants/addedTracer';
import _datePickerLocales from '@/locales/date-picker-locales';

export default {
    components: {
        VSelect,
        VTextField,
        VDateTimePicker,
        VTextarea,
    },
    props: {
        analysisRequest: {
            type: Object,
            default: () => ({}),
        },
        sampleAttribute: {
            type: String,
            default: '',
        },
        updateAnalysisRequest: {
            type: Function,
            default: () => {},
        },
        isSummaryView: {
            type: Boolean,
            default: false,
        },
        updateSample: {
            type: Function,
            default: () => {
            },
        },
    },
    computed: {
        addedTracer() {
            return addedTracer.map(type => ({
                name: this.$t(`addedTracer.${type}`),
                key: type,
            }));
        },
        activeSamples() {
            return this.analysisRequest.samples.map(sample => ({
                ...sample,
                name: sample.identification || sample.id,
            })).filter(u => u.status !== 'REFUSED');
        },
        systemVolumeLiter() {
            // (Quantité traceur actif (g)*100)/(Concentration en traceur (mg/L)-Concentration blanc (mg/L))
            const { activeTracerQuantity, initialTracerConcentration, blankConcentration } = this.analysisRequest.samples[0];
            const result = (activeTracerQuantity * 1000) / (initialTracerConcentration - blankConcentration);
            return Math.round(result) || 0;
        },
        systemVolumeImpGal() {
            const result = this.systemVolumeLiter / 4.546;
            return Math.round(result) || 0;
        },
        systemVolumeUsGal() {
            const result = this.systemVolumeLiter / 3.785;
            return Math.round(result) || 0;
        },
        timePeriodForWaterLosses() {
            // Date du prélèvement pour fuite - Date d'ajout du traceur
            const date1 = moment(this.analysisRequest.collectionLossDate);
            const date2 = moment(this.analysisRequest.tracerAddedDate);
            const diffInDays = date2.diff(date1, 'days');
            const result = Math.abs(diffInDays);

            return parseInt(result.toFixed(1), 10) || 0;
        },
        waterLossTotal() {
            // waterLossRate (L/j) * timePeriodForWaterLosses (j)
            const result = this.waterLossRate * this.timePeriodForWaterLosses;
            return parseFloat(result.toFixed(1)) || 0;
        },
        waterLossRate() {
            // eslint-disable-next-line max-len
            // (2.303 * systemVolume (L)) / timePeriodForWaterLosses (j) * (LOG(initialTracerConcentration (mg/L) - blankConcentration (mg/L)) - LOG(finalTracerConcentration (mg/L) - blankConcentration (mg/L)))
            const { initialTracerConcentration, blankConcentration, finalTracerConcentration } = this.analysisRequest.samples[0];
            const waterLossRate = ((2.303 * this.systemVolumeLiter) / (this.timePeriodForWaterLosses))
                    * (Math.log(parseFloat(initialTracerConcentration) - parseFloat(blankConcentration)) / Math.LN10
                    - Math.log(parseFloat(finalTracerConcentration) - parseFloat(blankConcentration)) / Math.LN10);
            if (Number.isNaN(waterLossRate)) {
                return 0;
            }
            return parseFloat(waterLossRate.toFixed(1));
        },
        datePickerLocales() {
            return _datePickerLocales;
        },
    },
};
</script>

<style lang="scss">
.volume-unit {
  .no-height-padding {
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
